module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Request For Quotation")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto",
    attrs: {
      "center": ""
    }
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("Request For Quotation\n              Order")])], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Request For Quotation"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.StatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.All_Research_Quotation_List_data
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": _vm.All_Research_Quotation_List_data
    },
    model: {
      value: (_vm.branchfilter),
      callback: function($$v) {
        _vm.branchfilter = $$v
      },
      expression: "branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "3"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "update": _vm.debounceSearch
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.stockList,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "common_over_id",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "RQ_ID",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                    " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                  ")])]
      }
    }, {
      key: "RQseries",
      fn: function(row9) {
        return [_c('span', {
          on: {
            "click": function($event) {
              _vm.viewAddRQPage(row9.item.RQ_ID)
            }
          }
        }, [_vm._v("\n                    " + _vm._s(row9.item.RQseries !=
          "" ? row9.item.RQseries : "--") + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Created Date : " + _vm._s(_vm._f("moment")(row9.item.creationTime)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row9.item.branchName))])]
      }
    }, {
      key: "placeOfIssue",
      fn: function(row1) {
        return [_c('span', [_vm._v(" " + _vm._s(row1.item.location != "" ? row1.item.location : "--"))])]
      }
    }, {
      key: "itemQuantity",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.itemName != "" ? row2.item.itemName : "--"))])]
      }
    }, {
      key: "isReseAndQuoActive",
      fn: function(row22) {
        return [_c('div', {
          attrs: {
            "id": 'row' + row22.item.RQ_ID
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row22.item.isReseAndQuoActive == 1 ? 'Active' : 'In-Active'))])], 1)])]
      }
    }, {
      key: "docuemnt_rfq",
      fn: function(row56) {
        return [(row56.item.docuemnt_rfq != null) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              _vm.PrintNote(row56.item.RQseries, row56.item.docuemnt_rfq)
            }
          }
        }, [_vm._v("PDF")]) : _c('span', [_vm._v("N/A")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79aa7289","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/maintenance/ResOfQuo/ResOfQuo.vue
// module id = 2762
// module chunks = 0